import React from "react";
import { Node } from "react-tech-tree";
import "react-tech-tree/dist/index.css";
import ReactTooltip from "react-tooltip";
import treeData from "../../data/tree.json";
import { IBoardTile } from "../../store/types";
import { stringifyCondition, replaceFinishDigits } from "../bitTextParser";

const UnlockRow = ({ label, data }: { label: string; data?: string[] }) =>
  data && data.length > 0 ? (
    <tr>
      <td>{`${label}${data.length > 1 ? "s" : ""}`}</td>
      <td>
        <table>
          <tbody>
            {data.map((entry, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <tr key={i}>
                <td>{replaceFinishDigits(entry)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </td>
    </tr>
  ) : null;

const parseConditions = (
  conditions?: IBoardTile["unlock"]["conditions"]
): string[] => {
  if (conditions === undefined) return [];
  return conditions.map(condition => {
    if (typeof condition === "string") return condition;
    return stringifyCondition(condition);
  });
};

const ToolTip = ({ cost, unlock, label }: IBoardTile) => {
  const { targets, conditions, actions } = unlock;
  const parsedConditions = parseConditions(conditions);
  return (
    <div className="nes-table-responsive node-tool-tip">
      <h3>{label}</h3>
      <table className="nes-table is-centered is-dark">
        <tbody>
          <tr>
            <td>Cost</td>
            <td>{`${cost} BP`}</td>
          </tr>
          <tr>
            <td>Unlocks</td>
            <td>
              <table>
                <tbody>
                  <UnlockRow label="target" data={targets} />
                  <UnlockRow label="condition" data={parsedConditions} />
                  <UnlockRow label="action" data={actions} />
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

type ITileKey = "blackMagic0" | "blackMagic1" | "greenMagic0";

export default function BoardNode(props: { id: string }) {
  const { id } = props as { id: ITileKey };
  const info = treeData.tiles[id] as IBoardTile;
  return (
    <>
      <Node {...props} data-for={`${id}-tooltip`} data-tip="" />
      <ReactTooltip id={`${id}-tooltip`} type="dark">
        {info && (
          <ToolTip cost={info.cost} unlock={info.unlock} label={info.label} />
        )}
      </ReactTooltip>
    </>
  );
}
